import { AppStateStatus } from 'react-native';

export type OnAppStateChange = (appState: AppStateStatus) => void;
export type UseUpdateOnAppStateChange = (callback: OnAppStateChange) => void;
